/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  ModalBody,
  Modal,
  ModalHeader,
  ModalFooter,
  Spinner,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap";
import { withRouter } from "react-router-dom";
import AddNewResource from "./AddNewResource";
import firebase from "../../../config/firebase";
import { toast } from "react-toastify";
import ReactHTMLParser from "react-html-parser";

class ResourcesList extends PureComponent {
  constructor() {
    super();
    this.state = {
      resources: [1, 2, 3],
      loading: false
    };
  }

  getTextOnlyFromHtmlString = htmlString => {
    //   Removing inline styles.
    const stringNoStyle = htmlString?.replace(/style="(.*?)" /g, "");
    // Removing Elements.
    return stringNoStyle?.replace(/<[^>]+>/g, "");
  };

  render() {
    const { resource } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            {resource ? (
              <>
                <h1>{resource.title}</h1>
                <div style={{ height: "200px" }}>
                  <img
                    src={resource.featureImage?.url}
                    alt=""
                    style={{ height: "100%", objectFit: "contain" }}
                  />
                </div>
                {ReactHTMLParser(resource.content)}
              </>
            ) : (
              <h4>No Data Found</h4>
            )}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withRouter(ResourcesList);
